<template>
  <div :class="'col-lg-'+ sizeLg + ' col-md-' + col + ' col-sm-' + sizeSm + ' col-' + colXs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BaseColumn",
  props: {
    col: {
      type: Number,
      default: 12,
      validator(value) {
        return value > 0 && value <= 12;
      }
    },
    colSm: {
      type: Number,
      validator(value) { return value > 0 && value <= 12; }
    },
    colLg: {
      type: Number,
      validator(value) { return value > 0 && value <= 12; }
    },
    colXs: {
      type: Number,
      default: 12,
      validator(value) { return value > 0 && value <= 12; }
    }
  },
  computed: {
    sizeSm() {
      if(this.colSm) return this.colSm;
      return this.col
    },
    sizeLg() {
      if(this.colLg) return this.colLg;
      return this.col
    }
  }
}
</script>

<style scoped>

</style>